// Cấu hình nhận dạng biển số ở camera UNI VIEW. Cấu hình khu vực
import { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './Config.module.css';
import classNames from 'classnames/bind';
import { Alert, Button, Toast } from '../../../../../components';
import { RefreshIcon, RestoreIcon, SquareIcon } from '../../../../../components/Icons/Icons';
import { isNearPoint, isPointOnLine, listAiTranslate } from '../../../../../utils';
import axiosClient from '../../../../../services/axiosClient';
import { ReactPlayer } from '../../../../../components';
import { SettingAIContext } from '../../../../../contexts';
import { useTranslation } from 'react-i18next';
import { licensePlateUniview } from '../../../../../services/api/lisencePlateUniview';
import { defaultValueRegionAPLRUniview, laneLineUniViewAlpr } from '../source';
const cx = classNames.bind(style);

const width = 490;
const height = 280;
const widthUniview = 10000;
const heightUniview = 10000;
const rangeX = width / widthUniview;
const rangeY = height / heightUniview;

function ConfigZoneCamUniview() {
    const { nameService, cameraCode, codeService, permissionChange, onClose, setIsLoading, showReload,setShowReload } = useContext(SettingAIContext)
    const canvasRef = useRef(null);
    const [lines, setLines] = useState([]);
    const [canvas, setCanvas] = useState(null);
    const [draw, setDraw] = useState(false);
    const [alert, setAlert] = useState(false);
    const [reGetData, setReGetData] = useState(false);
    const [path, setPath] = useState();
    const [dragPoint, setDragPoint] = useState(null);
    const [selectedLineIndex, setSelectedLineIndex] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [numLanes, setNumLanes] = useState(1);
    const { t } = useTranslation();

    const getLines = (res) => {
        const listLine = [];
        const lanesLine = res?.lanes_line;
        const triggerLine = res?.trigger_line;
        lanesLine?.forEach(lane => {
            const line = {
                x1: lane?.LineLocation?.Tail?.X * rangeX,
                x2: lane?.LineLocation?.Head?.X * rangeX,
                y1: lane?.LineLocation?.Tail?.Y * rangeY,
                y2: lane?.LineLocation?.Head?.Y * rangeY,
                type: 'lane',
                ...lane,
            }
            listLine?.push(line);
        })
        triggerLine?.forEach(lane => {
            const line = {
                x1: lane?.LineLocation?.Tail?.X * rangeX,
                x2: lane?.LineLocation?.Head?.X * rangeX,
                y1: lane?.LineLocation?.Tail?.Y * rangeY,
                y2: lane?.LineLocation?.Head?.Y * rangeY,
                type: 'trigger',
                ...lane,
            }
            listLine?.push(line);
        })
        return listLine;
    }

    const getConfigRoi = async () => {
        try {
            const params = {
                camera_code: cameraCode
            }
            const res = await licensePlateUniview.get(params);
            if (res) {
                const listLine = getLines(res);
                setLines(listLine);
            }
        } catch (error) {
            Toast.open(t('setting.Unable_to_extract_recognition_areas'), 'danger')
        }
    }
    const getNumLanes = async () => {
        try {
            const params = {
                camera_code: cameraCode
            }
            const res = await licensePlateUniview.getNumlanes(params);
            if (res) {
                setNumLanes(res?.num_lanes);
            }
        } catch (error) {
            Toast.open(t('setting.Unable_to_extract_recognition_areas'), 'danger')
        }
    }

    const getPathStreaming = async () => {
        try {
            const res = await axiosClient.get(`camVideoQuality/get-cam-video-quality-for-config-roilist/?camera_code=${cameraCode}`)
            if (res && res.length > 0) {
                setPath(res[0].PATH);
            }
        } catch (error) {
            Toast.open(t('setting.No_images'), 'danger')
        }
    }

    useEffect(() => {
        setCanvas(canvasRef.current);
        const getData = async () => {
            if (canvasRef) {
                await getPathStreaming();
                await getNumLanes();
                await getConfigRoi();
            }
        }
        getData()
    }, [canvasRef, reGetData, cameraCode, nameService])

    const drawLine = (ctx, line, color, label) => {
        const { x1, y1, x2, y2 } = line;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.strokeStyle = color;
        ctx.lineWidth = 4;
        ctx.stroke();
        const midX = (x1 + x2) / 2;
        const midY = (y2 + y2) / 2;
        ctx.font = '14px Arial';
        ctx.fillStyle = color;
        ctx.textAlign = 'center';
        ctx.fillText(label || `Line`, midX, midY - 10);
    };

    const drawEndpoints = (ctx, info) => {
        const { x1, y1, x2, y2 } = info;
        ctx.fillStyle = 'white'; // Color of the endpoint circles
        const radius = 5;
        // Draw circle at the starting point
        ctx.beginPath();
        ctx.arc(x1, y1, radius, 0, Math.PI * 2);
        ctx.fill();
        // Draw circle at the ending point
        ctx.beginPath();
        ctx.arc(x2, y2, radius, 0, Math.PI * 2);
        ctx.fill();
    };

    useEffect(() => {
        if (canvas) {
            const ctx = canvas.getContext("2d");
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            lines?.forEach((line, index) => {
                if (line.type === 'trigger') {
                    drawLine(ctx, line, 'red', 'Dòng kích hoạt');
                } else {
                    drawLine(ctx, line, 'white', `Làn đường ${index + 1}`);
                }
                if (index === selectedLineIndex) {
                    drawEndpoints(ctx, line);
                }
            })
        }

    }, [canvas, nameService, lines, selectedLineIndex])

    const handleCanvasClick = (e) => {
        setShowReload(true)
        const rect = canvas?.getBoundingClientRect();
        const mouseX = e.clientX - rect?.left;
        const mouseY = e.clientY - rect?.top;
        const hitIndex = lines.findIndex((line) =>
            isPointOnLine(mouseX, mouseY, line)
        );
        if (hitIndex !== -1) {
            setSelectedLineIndex(hitIndex);
            const line = lines[hitIndex];
            // Determine if the user is grabbing one of the endpoints or the line itself
            if (isNearPoint(mouseX, mouseY, { x: line.x1, y: line.y1 })) {
                setDragPoint('start');
            } else if (isNearPoint(mouseX, mouseY, { x: line.x2, y: line.y2 })) {
                setDragPoint('end');
            } else {
                setDragPoint('line');
            }
            setIsDragging(true);
        }
    }

    // call api apply setting

    const putUpdateNumLanes = async (num) => {
        try {
            const param = {
                camera_code: cameraCode
            };
            const numLine = {
                num_lanes: num
            }
            const res = await licensePlateUniview.putSetNumlanes(param, numLine)
        } catch (error) {
            throw error;
        }
    }

    const putUpdateConfig = async (lines) => {
        setIsLoading(true);
        try {
            const lanes_lines = lines?.filter(line => line?.type === 'lane')?.map(line => {
                return {
                    Enabled: line?.Enabled,
                    LineID: line?.LineID,
                    LineLocation: {
                        Head: {
                            X: line?.x2 / rangeX,
                            Y: line?.y2 / rangeY,
                        },
                        Tail: {
                            X: line?.x1 / rangeX,
                            Y: line?.y1 / rangeY,
                        }
                    }
                }
            });
            const trigger_line = lines?.filter(line => line?.type === 'trigger')?.map(line => {
                return {
                    Enabled: line?.Enabled,
                    LineID: line?.LineID,
                    LineType: line?.LineType,
                    LineLocation: {
                        Head: {
                            X: line?.x2 / rangeX,
                            Y: line?.y2 / rangeY,
                        },
                        Tail: {
                            X: line?.x1 / rangeX,
                            Y: line?.y1 / rangeY,
                        }
                    }
                }
            });
            const info = {
                lanes_lines: {
                    LineInfoList: lanes_lines,
                },
                trigger_line: {
                    TriggerLineInfo: trigger_line,
                }
            }
            const params = {
                camera_code: cameraCode,
            }
            await licensePlateUniview.put(info, params);
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.success')}`, 'success');
            setIsLoading(false);
        } catch (error) {
            console.log(error);
            Toast.open(`${t('setting.Setting')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr || nameService} ${t('stream.error')}`, 'danger');
            setIsLoading(false);
        }
    }

    // x1 y1, x2 , y2
    const handleUpdate = async () => {
        try {
           await putUpdateNumLanes(numLanes);
           await putUpdateConfig(lines);
        } catch (error) {
            console.log(error);
        }
    }

    const handleDelete = () => {
        setAlert(!alert);
    }

    const handleDraw = () => {
        setShowReload(true)
        setDraw(!draw);
    }

    const handleRestore = () => {
        const listLine = getLines(defaultValueRegionAPLRUniview);
        setLines(listLine);
    }

    const reFreshConfig = async () => {
        try {
            const listLine = getLines(defaultValueRegionAPLRUniview);
            await putUpdateNumLanes(1);
            await putUpdateConfig(listLine);
            setLines(listLine);
            setNumLanes(1);
            setAlert(!alert);
        } catch (error) {
            console.log(error);
        }
    }

    useLayoutEffect(() => {
        if (canvas) {
            // Fix size off canvas if screen hight quality
            const dpr = window.devicePixelRatio;
            const rect = canvas.getBoundingClientRect();
            canvas.width = rect.width * dpr;
            canvas.height = rect.height * dpr;
            const ctx = canvas.getContext("2d");
            ctx.scale(dpr, dpr);
            canvas.style.width = `${rect.width}px`;
            canvas.style.height = `${rect.height}px`;
            // Clear when remount or remove canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
    }, [canvas]);

    const handleCancel = () => {
        // onClose()
        setReGetData(!reGetData);
    }

    const handleMouseMove = (e) => {
        if (!isDragging || selectedLineIndex === null) return;
        setShowReload(true)
        const rect = canvas.getBoundingClientRect();
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;

        const updatedLines = [...lines];
        const line = updatedLines[selectedLineIndex];

        if (dragPoint === 'start') {
            line.x1 = mouseX;
            line.y1 = mouseY;
        } else if (dragPoint === 'end') {
            line.x2 = mouseX;
            line.y2 = mouseY;
        } else if (dragPoint === 'line') {
            const dx = mouseX - (line.x1 + (line.x2 - line.x1) / 2);
            const dy = mouseY - (line.y1 + (line.y2 - line.y1) / 2);
            line.x1 += dx;
            line.y1 += dy;
            line.x2 += dx;
            line.y2 += dy;
        }

        setLines(updatedLines);
    };

    const handleMouseUp = () => {
        setShowReload(true)
        setIsDragging(false);
        setDragPoint(null);
        setSelectedLineIndex(null);
    };

    const onChangeNumLanes = (e) => {
        const value = Number(e.target.value);
        if (value >= 1 && value <= 4) {
            let lanes = lines?.filter(line => line?.type === 'lane');
            const triger = lines?.filter(line => line?.type !== 'lane');
            const check = !!lanes?.find(lane => lane?.LineID === value + 1);
            if (check) {
                lanes = lanes?.filter(lane => lane?.LineID <= value + 1);
            } else {
                const newLane = {
                    LineID: value + 1,
                    x1: laneLineUniViewAlpr?.LineLocation?.Tail?.X * rangeX,
                    x2: laneLineUniViewAlpr?.LineLocation?.Head?.X * rangeX,
                    y1: laneLineUniViewAlpr?.LineLocation?.Tail?.Y * rangeY,
                    y2: laneLineUniViewAlpr?.LineLocation?.Head?.Y * rangeY,
                    type: 'lane',
                    ...laneLineUniViewAlpr,
                }
                lanes.push(newLane);
            }
            setLines([...lanes, ...triger]);
            setNumLanes(value);
        }
    }

    return (
        <>
            {alert && <Alert onClose={() => setAlert(!alert)} onOk={() => reFreshConfig()} title={` ${t('setting.Confirm_reset_to_default')}`} />}
            <div className={cx('list-config')}>
                <div className={cx('list-config-name')}>{
                    `${t('setting.Regional_configuration')} ${listAiTranslate.find(ai => ai.ai_name === nameService)?.name_tr?.toLocaleLowerCase() || nameService.toLowerCase()}`}
                </div>
                <div className={cx('draw-container')}>
                    <div className={cx('box-video')} style={{ width: `${width}px` }}>
                        {path ? (
                            <ReactPlayer
                                url={`${process.env.REACT_APP_BASE_URL}livestream${path}`}
                                height={`${height}px`}
                            />
                        ) : (
                            <div style={{ width: '100%', height: `${height + 1}px` }}>
                                <p className={cx('no-image')}>{t('location.cameraIsOff')}</p>
                            </div>
                        )}
                        <canvas
                            ref={canvasRef}
                            className={cx('canvas-space')}
                            style={{
                                width: '100%',
                                height: `${height}px`,
                            }}
                            onMouseDown={handleCanvasClick}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                        />
                    </div>
                </div>
                <div className={cx('controller-draw')}>
                    <div className={cx('left-button')}>
                        <button className={cx('button-control')} onClick={() => setReGetData(!reGetData)}>
                            {t("setting.Refresh_image")}
                            <RefreshIcon />
                        </button>
                        <button className={cx('button-control', draw && 'active')} onClick={handleDraw}>
                            {t("setting.Drawing")}
                            <SquareIcon />
                        </button>
                    </div>
                    <div className={cx('right-button')}>
                        <button className={cx('button-control')} onClick={handleRestore}>
                            <RestoreIcon />
                        </button>
                    </div>
                    <div className={cx('crop_region')}>
                        <p>Số làn đường:</p>
                        <input
                            type='number'
                            max={4}
                            min={1}
                            step={1}
                            className={cx("input_crop_region")}
                            onChange={(e) => {
                                setShowReload(true)
                                onChangeNumLanes(e)
                            }}
                            value={numLanes}
                        />
                    </div>
                </div>
            </div>
            {permissionChange && (
                <div className={cx("actions-setting")}>
                    <Button
                        onClick={handleDelete}
                        className={cx("btn-save")}
                        title={t('setting.Reset_to_default')}
                    />
                    {
                        showReload && <Button className={cx("btn-cancle")} title={t('cameraControl.Cancel')} onClick={handleCancel} />
                    }
                    <Button
                        onClick={handleUpdate}
                        className={cx("btn-save")}
                        title={t('settingCam.Save_settings')}
                    />
                </div>
            )}
        </>
    )
}

export default ConfigZoneCamUniview;